import { PropsWithChildren } from "react";

import { Text } from "@krea/customer-features/shared-components/text";
import twMerge from "@krea/customer-features/utils/tailwind-utils";

interface IBidsListTableTDProps {
  className?: string;
  isText?: boolean;
  scrollable?: boolean;
  first?: boolean;
  heading?: string | null;
  colSpan?: number;
}

const BidsListTableTD = ({
  className,
  children,
  isText,
  scrollable,
  first,
  heading,
  colSpan,
  ...rest
}: PropsWithChildren<IBidsListTableTDProps>) => {
  const content = children;

  return (
    <td
      className={twMerge(
        "tw-py-2 tw-my-auto",
        {
          "tw-pl-8 tw-min-w-[160px]": !first,
          "tw-max-w-[120px] tw-overflow-x-auto": scrollable,
        },
        className,
      )}
      colSpan={colSpan}
      {...rest}
    >
      <Text size="sm" className="tw-text-nowrap tw-text-gray-600">
        {heading}
      </Text>
      {isText ? (
        <Text size="sm" className="tw-text-nowrap tw-font-bold">
          {content}
        </Text>
      ) : (
        content
      )}
    </td>
  );
};

export default BidsListTableTD;
